import { render, staticRenderFns } from "./HospitalIncidentsToolbar.vue?vue&type=template&id=b21e6962&"
import script from "./HospitalIncidentsToolbar.vue?vue&type=script&lang=js&"
export * from "./HospitalIncidentsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./HospitalIncidentsToolbar.vue?vue&type=style&index=0&id=b21e6962&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports